import { Phone } from "lucide-react";
import { useGetList, useTranslate } from "ra-core";
import { Link } from "react-router";
import { IS_DEMO } from "../env";

/** "Commencer à appeler" with the queue size (v_my_queue_preview returns at most 20 rows). Hidden size in the demo. */
export const StartCallingCta = () => {
  const translate = useTranslate();
  const { total, error } = useGetList(
    "v_my_queue_preview",
    { pagination: { page: 1, perPage: 20 } },
    { enabled: !IS_DEMO, retry: false },
  );
  const size =
    error || total == null ? null : total >= 20 ? "20+" : String(total);
  return (
    <Link
      to="/appeler"
      className="flex items-center justify-between gap-4 rounded-xl bg-primary px-5 py-4 text-primary-foreground shadow-[0_0_24px_-6px_rgba(247,113,25,.35)] outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
    >
      <span className="flex items-center gap-3 text-base font-bold">
        <Phone className="size-5" aria-hidden="true" />
        {translate("gavion.dashboard.start_calling")}
      </span>
      {size != null && (
        <span className="rounded-full bg-black/20 px-3 py-1 text-sm font-bold tabular-nums">
          {translate("gavion.dashboard.queue_size", { size })}
        </span>
      )}
    </Link>
  );
};
